module.exports = __webpack_public_path__ + "img/charity_thumbnail-600x450.caa6a2de.jpg";